import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'
import { STEP_ROUTE_MAP } from '../store/onboarding'

import AuthLayout from '../components/AuthLayout.vue'
import LoginComponent from '../components/LoginComponent.vue'
import RegistrationComponent from '../components/RegistrationComponent.vue'
import RegistrationSuccessComponent from '../components/RegistrationSuccessComponent.vue'
import EmailVerificationComponent from '../components/EmailVerificationComponent.vue'
import OnboardingLayout from '../components/onboarding/OnboardingLayout.vue'
import MainLayout from '../components/MainLayout.vue'
import DashboardComponent from '../components/DashboardComponent.vue'

const routes = [
    {
        path: '/pricing',
        name: 'pricing',
        component: () => import('../components/PricingPage.vue'),
        meta: { middleware: 'guest' },
    },
    {
        path: '/',
        component: AuthLayout,
        children: [
            {
                path: '',
                name: 'login',
                component: LoginComponent,
                meta: { middleware: 'guest' },
            },
            {
                path: '/registration',
                name: 'registration',
                component: RegistrationComponent,
                meta: { middleware: 'guest' },
            },
            {
                path: '/registration/success',
                name: 'registration.success',
                component: RegistrationSuccessComponent,
                meta: { middleware: 'guest' },
            },
            {
                path: '/email-verification',
                name: 'email.verification',
                component: EmailVerificationComponent,
                meta: { middleware: 'guest' },
            },
        ],
    },
    {
        path: '/onboarding',
        component: OnboardingLayout,
        meta: { middleware: 'auth' },
        children: [
            {
                path: 'profession',
                name: 'onboarding.profession',
                component: () => import('../components/onboarding/ProfessionStep.vue'),
                meta: { middleware: 'auth', stepKey: 'profession' },
            },
            {
                path: 'website',
                name: 'onboarding.website',
                component: () => import('../components/onboarding/WebsiteStep.vue'),
                meta: { middleware: 'auth', stepKey: 'website' },
            },
            {
                path: 'header',
                name: 'onboarding.header',
                component: () => import('../components/onboarding/HeaderStep.vue'),
                meta: { middleware: 'auth', stepKey: 'header' },
            },
            {
                path: 'avatar',
                name: 'onboarding.avatar',
                component: () => import('../components/onboarding/AvatarStep.vue'),
                meta: { middleware: 'auth', stepKey: 'avatar' },
            },
            {
                path: 'services',
                name: 'onboarding.services',
                component: () => import('../components/onboarding/ServicesStep.vue'),
                meta: { middleware: 'auth', stepKey: 'services' },
            },
            {
                path: 'schedule',
                name: 'onboarding.schedule',
                component: () => import('../components/onboarding/ScheduleStep.vue'),
                meta: { middleware: 'auth', stepKey: 'schedule' },
            },
            {
                path: 'gallery',
                name: 'onboarding.gallery',
                component: () => import('../components/onboarding/GalleryStep.vue'),
                meta: { middleware: 'auth', stepKey: 'gallery' },
            },
            {
                path: 'telephone',
                name: 'onboarding.telephone',
                component: () => import('../components/onboarding/TelephoneStep.vue'),
                meta: { middleware: 'auth', stepKey: 'telephone' },
            },
            {
                path: 'email',
                name: 'onboarding.email',
                component: () => import('../components/onboarding/EmailStep.vue'),
                meta: { middleware: 'auth', stepKey: 'email' },
            },
            {
                path: 'social',
                name: 'onboarding.social',
                component: () => import('../components/onboarding/SocialStep.vue'),
                meta: { middleware: 'auth', stepKey: 'social' },
            },
            {
                path: 'impressum',
                name: 'onboarding.impressum',
                component: () => import('../components/onboarding/ImpressumStep.vue'),
                meta: { middleware: 'auth', stepKey: 'impressum' },
            },
        ],
    },
    {
        path: '/_ml',
        component: MainLayout,
        meta: { middleware: 'auth' },
        children: [
            {
                path: '/website',
                name: 'website',
                component: DashboardComponent,
                meta: { middleware: 'auth' },
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('../components/ProfileComponent.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/communication',
                name: 'communication',
                component: () => import('../components/CommunicationComponent.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/schedules',
                name: 'website.schedules',
                props: true,
                component: () => import('../components/ScheduleComponent.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/schedules/create',
                name: 'website.schedules.create',
                props: true,
                component: () => import('../components/wrappers/ScheduleFormWrapper.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/schedules/:scheduleId/edit',
                name: 'website.schedules.edit',
                props: true,
                component: () => import('../components/wrappers/ScheduleFormWrapper.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/appointment-types',
                name: 'website.appointment-types',
                props: true,
                component: () => import('../components/ServicesComponent.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/appointment-types/create',
                name: 'website.appointment-types.create',
                props: true,
                component: () => import('../components/wrappers/AppointmentTypeFormWrapper.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/appointment-types/:typeId/edit',
                name: 'website.appointment-types.edit',
                props: true,
                component: () => import('../components/wrappers/AppointmentTypeFormWrapper.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/ai-suggested-services',
                name: 'website.ai-suggested-services',
                props: true,
                component: () => import('../components/wrappers/AISuggestedServicesWrapper.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/appointments',
                name: 'website.appointments',
                props: true,
                component: () => import('../components/AppointmentsComponent.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/appointments/history',
                name: 'website.appointments.history',
                props: true,
                component: () => import('../components/wrappers/AppointmentHistoryWrapper.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/pages/:pageId/element/:elementId',
                name: 'pages.element.edit',
                props: true,
                component: () => import('@webapp/components/PageElement/ElementEditComponent.vue'),
                meta: { middleware: 'auth' },
            },
            {
                path: '/websites/:websiteId/pages/:pageId/element/:elementId/style',
                name: 'pages.element.style',
                props: true,
                component: () => import('@webapp/components/PageElement/BlockStylerComponent.vue'),
                meta: { middleware: 'auth' },
            },
        ],
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.state.auth.authenticated
    const allRequiredDone = store.getters['onboarding/allRequiredComplete']

    if (to.meta.middleware === 'auth' && !isAuthenticated) {
        return next({ name: 'login' })
    }

    if (to.meta.middleware === 'guest' && isAuthenticated) {
        if (allRequiredDone) {
            return next({ name: 'website' })
        }
        const firstIncomplete = store.getters['onboarding/firstIncompleteRequiredStep']
        if (firstIncomplete && STEP_ROUTE_MAP[firstIncomplete.key]) {
            return next({ name: STEP_ROUTE_MAP[firstIncomplete.key] })
        }
        return next({ name: 'onboarding.profession' })
    }

    if (to.name === 'website' && !allRequiredDone) {
        const firstIncomplete = store.getters['onboarding/firstIncompleteRequiredStep']
        if (firstIncomplete && STEP_ROUTE_MAP[firstIncomplete.key]) {
            return next({ name: STEP_ROUTE_MAP[firstIncomplete.key] })
        }
        return next({ name: 'onboarding.profession' })
    }

    next()
})

export default router
